import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const keys = () =>
  createEnv({
    client: {
      NEXT_PUBLIC_BILLING_PRICE_SMALL_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_SMALL_YEAR_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_MEDIUM_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_MEDIUM_YEAR_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_LARGE_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_LARGE_YEAR_ID: z.string().optional()
    },
    server: {
      BILLING_STRIPE_SECRET_KEY: z.string().optional(),
      BILLING_STRIPE_WEBHOOK_SECRET: z.string().optional()
    },
    runtimeEnv: {
      NEXT_PUBLIC_BILLING_PRICE_SMALL_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_SMALL_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_SMALL_YEAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_SMALL_YEAR_ID,
      NEXT_PUBLIC_BILLING_PRICE_MEDIUM_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_MEDIUM_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_MEDIUM_YEAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_MEDIUM_YEAR_ID,
      NEXT_PUBLIC_BILLING_PRICE_LARGE_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_LARGE_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_LARGE_YEAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_LARGE_YEAR_ID,
      BILLING_STRIPE_SECRET_KEY: process.env.BILLING_STRIPE_SECRET_KEY,
      BILLING_STRIPE_WEBHOOK_SECRET: process.env.BILLING_STRIPE_WEBHOOK_SECRET
    }
  });
